<template>
  <div class="login-wrap relative w-full h-screen overflow-hidden flex items-center justify-center bg-surface">
    <!-- 背景图 -->
    <div class="absolute inset-0 bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + require('@/assets/img/login-background.jpg') + ')' }"></div>
    
    <!-- 背景渐变遮罩 -->
    <div class="absolute inset-0 z-10" style="background: linear-gradient(to right, rgba(27, 54, 93, 0.9), rgba(27, 54, 93, 0.4));"></div>
    
    <!-- 登录卡片 -->
    <div class="relative z-20 bg-white rounded-[8px] pt-[40px] px-[35px] pb-[40px] w-full max-w-[560px] shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04)] mx-4">
      <h2 class="text-[#1B365D] text-[24px] font-bold border-l-[5px] border-[#C5A059] pl-[15px] mb-[20px] leading-[1.4] font-['Work_Sans','Microsoft_YaHei',sans-serif] text-left">
        四川省企业管理现代化创新成果<br/>论著文申报平台
      </h2>
      <div class="mb-[25px] text-[18px] text-[#1B365D] font-bold pl-[20px] text-left">账号登录</div>
      
      <form @submit.prevent="handleLogin" class="space-y-[20px]">
        <!-- 账号 -->
        <div class="relative">
          <span class="absolute left-[15px] top-1/2 -translate-y-1/2 text-gray-400 flex items-center">
            <span class="material-symbols-outlined text-[18px]">person</span>
          </span>
          <input type="text" v-model="form.username" placeholder="账号" required
            class="w-full h-[40px] pl-[40px] pr-[15px] bg-[#f7f9fc] border border-[#e6e8eb] rounded-[6px] focus:outline-none focus:border-[#C5A059] focus:shadow-[inset_0_0_0_1px_#C5A059] transition-colors text-gray-700 text-[14px]">
        </div>
        
        <!-- 密码 -->
        <div class="relative">
          <span class="absolute left-[15px] top-1/2 -translate-y-1/2 text-gray-400 flex items-center">
            <span class="material-symbols-outlined text-[18px]">lock</span>
          </span>
          <input type="password" v-model="form.password" placeholder="密码" required
            class="w-full h-[40px] pl-[40px] pr-[15px] bg-[#f7f9fc] border border-[#e6e8eb] rounded-[6px] focus:outline-none focus:border-[#C5A059] focus:shadow-[inset_0_0_0_1px_#C5A059] transition-colors text-gray-700 text-[14px]">
        </div>
        
        <!-- 验证码 -->
        <div class="flex gap-4" v-if="captchaEnabled">
          <div class="relative flex-1">
            <span class="absolute left-[15px] top-1/2 -translate-y-1/2 text-gray-400 flex items-center">
              <span class="material-symbols-outlined text-[18px]">memory</span>
            </span>
            <input type="text" v-model="form.code" placeholder="验证码" required
              class="w-full h-[40px] pl-[40px] pr-[15px] bg-[#f7f9fc] border border-[#e6e8eb] rounded-[6px] focus:outline-none focus:border-[#C5A059] focus:shadow-[inset_0_0_0_1px_#C5A059] transition-colors text-gray-700 text-[14px]">
          </div>
          <div class="w-[120px] h-[40px] bg-[#f7f9fc] border border-[#e6e8eb] rounded-[6px] overflow-hidden cursor-pointer shrink-0" @click="getCode">
            <img v-if="codeUrl" :src="codeUrl" alt="验证码" class="w-full h-[40px] object-cover pl-[12px]">
          </div>
        </div>
        
        <!-- 记住密码 -->
        <div class="flex items-center mt-[-5px]">
          <input type="checkbox" id="rememberMe" v-model="form.rememberMe" 
            class="w-[14px] h-[14px] text-[#C5A059] border-[#e6e8eb] rounded focus:ring-0 accent-[#C5A059] cursor-pointer">
          <label for="rememberMe" class="ml-[8px] text-[14px] text-[#606266] cursor-pointer">记住密码</label>
        </div>
        
        <!-- 登录按钮 -->
        <div class="mt-[10px]">
          <button type="submit" :disabled="loading"
            class="w-full h-[40px] bg-[#C5A059] text-white rounded-[6px] font-bold text-[14px] hover:bg-[#b08d4a] hover:-translate-y-[2px] transition-all duration-300 disabled:opacity-70 flex justify-center items-center gap-2">
            <span v-if="loading" class="material-symbols-outlined animate-spin text-[18px]">refresh</span>
            {{ loading ? '登 录 中...' : '登 录' }}
          </button>
        </div>
        
        <!-- 注册链接 -->
        <div class="text-right text-[14px] mt-[10px]">
          <span class="text-[#606266]">没有账号？去</span>
          <a :href="registerUrl" class="text-[#C5A059] font-bold hover:text-[#1B365D] hover:underline transition-colors">注册</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { buildPortalApplyUrl } from '@/utils/portal'

export default {
  name: 'DeclareLogin',
  computed: {
    homepageReturnUrl () {
      const returnUrl = this.$route.query.returnUrl
      const normalizedPath = typeof returnUrl === 'string' && returnUrl.startsWith('/')
        ? returnUrl
        : '/home'
      return new URL(normalizedPath, window.location.origin).toString()
    },
    portalEntryQuery () {
      return {
        source: this.$route.query.source === 'homepage' ? 'homepage' : '',
        returnUrl: this.homepageReturnUrl
      }
    },
    registerUrl () {
      return buildPortalApplyUrl('/register', this.portalEntryQuery)
    }
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        rememberMe: false,
        code: '',
        uuid: ''
      },
      codeUrl: '',
      captchaEnabled: true,
      loading: false
    }
  },
  mounted() {
    this.getCode()
    // 简易读取 Cookie 的逻辑（如果有的话，也可以忽略，交给浏览器记住密码）
  },
  methods: {
    async getCode() {
      try {
        const response = await fetch('/dev-api/captchaImage')
        const res = await response.json()
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.form.uuid = res.uuid
        }
      } catch (error) {
        console.error('获取验证码失败', error)
      }
    },
    async handleLogin() {
      if (!this.form.username || !this.form.password) {
        alert('请输入账号和密码')
        return
      }
      if (this.captchaEnabled && !this.form.code) {
        alert('请输入验证码')
        return
      }
      
      this.loading = true
      try {
        const response = await fetch('/dev-api/portal/open/declare/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify({
            username: this.form.username,
            password: this.form.password,
            code: this.form.code,
            uuid: this.form.uuid
          })
        })
        
        const res = await response.json()
        
        if (res.code === 200) {
          // 登录成功，携 token 跳转至管理后台
          window.location.replace(buildPortalApplyUrl('/index', {
            token: res.token,
            ...this.portalEntryQuery
          }))
        } else {
          const msg = res.msg || '登录失败'
          alert(msg)
          if (msg.includes('管理端登录') && window.confirm('该账号需从管理端登录入口进入，是否立即跳转？')) {
            window.location.replace(buildPortalApplyUrl('/login', this.portalEntryQuery))
            return
          }
          this.getCode()
        }
      } catch (error) {
        console.error('登录异常', error)
        alert('网络错误或服务器异常')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* 覆盖原生的 checkbox 颜色，Tailwind 的 accent-color 在部分浏览器可能需要辅助 */
input[type="checkbox"] {
  accent-color: #C5A059;
}
</style>



// WEBPACK FOOTER //
// src/views/DeclareLogin.vue